import Logo from "./Logo";
import { Link } from "react-router-dom";
import "../css/footer.css";
import { useContacts } from "../context/ContactsContext";

function Footer() {
  const { contacts } = useContacts();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-logo">
            <Logo />
          </div>
        </div>

        <div className="footer-right">
          <nav className="footer-links" aria-label="Footer links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <Link to="/contatti">Contatti</Link>
            {/* Social / contact icons */}
            <a
              className="footer-icon"
              href={contacts.FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pagina Facebook di Fer-Al"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07c0 4.99 3.66 9.13 8.44 9.93v-7.03H8.08v-2.9h2.36V9.41c0-2.33 1.39-3.62 3.52-3.62.99 0 2.03.18 2.03.18v2.23h-1.14c-1.12 0-1.47.7-1.47 1.42v1.7h2.5l-.4 2.9h-2.1v7.03C18.34 21.2 22 17.06 22 12.07z" />
              </svg>
            </a>

            <a
              className="footer-icon"
              href={contacts.MAILTO}
              aria-label="Invia una email a Fer-Al"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
            </a>
          </nav>

          <div className="footer-legal">
            <address>
              <strong>{contacts.COMPANY_NAME}</strong>
              <br />
              Sede legale: {contacts.ADDRESS_LINE}, {contacts.ADDRESS_CITY}
            </address>

            <div className="legal-columns">
              <div className="col">
                <div>P. IVA: {contacts.VAT_NUMBER}</div>
                <div>REA: {contacts.REA_NUMBER}</div>
              </div>
              <div className="col">
                <div>PEC: {contacts.PEC_EMAIL}</div>
                <div>Email: {contacts.CONTACT_EMAIL}</div>
                <div>Tel: {contacts.PHONE_DISPLAY}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} {contacts.COMPANY_NAME}. Tutti i
          diritti riservati.
        </p>
        <p className="footer-powered">Powered by davis00105@gmail.com</p>
      </div>
    </footer>
  );
}

export default Footer;
